import {
    apiRequest,
    AcManajerialList
} from "../../../../../services/adapters/Assesment/assesmentService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", AcManajerialList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default DataTableRepository